import type { ShirtData } from "./types";

interface UseCanvasVisibilityParams {
  shirtData: ShirtData | null;
  artworkImage?: HTMLImageElement | undefined;
  readonly: boolean;
  isSelected: boolean;
  isDragging: boolean;
  roundedWidth: number;
  roundedHeight: number;
}

interface CanvasVisibility {
  showPrintableArea: boolean;
  showNeckline: boolean;
  showWidthLabel: boolean;
  showHeightLabel: boolean;
}

export function useCanvasVisibility({
  shirtData,
  artworkImage,
  readonly,
  isSelected,
  isDragging,
  roundedWidth,
  roundedHeight
}: UseCanvasVisibilityParams): CanvasVisibility {
  const baseVisible = Boolean(shirtData && artworkImage && !readonly && isSelected) || isDragging;

  return {
    showPrintableArea: baseVisible,
    showNeckline: baseVisible,
    showWidthLabel: baseVisible && roundedWidth > 0,
    showHeightLabel: baseVisible && roundedHeight > 0
  };
}
